
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'app',
  methods: {
    getPopupContainer (node) {
      // 过滤掉下拉菜单的情况 这两种情况挂载于全局
      const reg = /(ant-dropdown-trigger|ant-btn|ant-popover-open|ant-tooltip-open)/g
      if (node && !reg.test(node.className)) {
        return node.parentNode
      }
      return this.$refs.resourceApp
    },
    // 对table 的空数据进行兼容
    handleTransformCellText ({ text }) {
      if (text === undefined || text === null || typeof text === 'string') {
        return text && text.length > 0 ? text : '-'
      }
      return text
    }
  },
  setup () {
    return {
      zhCN
    }
  }
}
